module.exports = __webpack_public_path__ + "static/img/nt6.ae14a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/nt6.jpg
// module id = Kbtc
// module chunks = 0